import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { TableCell } from '../TableCell';
import { TableCellContentType } from '../TableCell/types';
import { TableRow } from '../TableRow';
import { TableLoaderBar } from './styled';
export const TableLoader = React.memo(function TableLoader({ columnsLength, rows = 3, dataTestId }) {
    const rowsArray = React.useMemo(() => [...Array.from({ length: rows }, (_, i) => i)], [rows]);
    const columnsArray = React.useMemo(() => [...Array.from({ length: columnsLength }, (_, i) => i)], [columnsLength]);
    return (_jsx(_Fragment, { children: rowsArray.map((i) => (_jsx(TableRow, { dataTestId: dataTestId, children: columnsArray.map((j) => (_jsx(TableCell, { contentType: TableCellContentType.LOADING, children: _jsx(TableLoaderBar, {}) }, j))) }, i))) }));
});
